import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EditPhoneModal from '@/shared/components/channels/EditPhoneModal.vue';
import { updateContactPhone } from '../../infrastructure/adapters/contactService';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactEditPhoneModal',
    props: /*@__PURE__*/ _mergeModels({
        contactId: {},
        channelId: {},
        initialValue: {},
        initialIsPrimary: { type: Boolean },
        initialSubType: {}
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["updated", "delete"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        /**
         * Contact binding of the reusable {@link EditPhoneModal} (OP-5611 / US-15).
         *
         * Injects the contact-specific persistence (`updateContactPhone`, a BFF read-merge-write PUT that
         * preserves the channel's label/usage/linked organisation and changes only value + subtype + primary).
         * Reuses the "Ajouter un numéro" field labels (`fieldI18nPrefix`) for visual/textual consistency.
         */
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        // errorCode → i18n key (R70). The 255-char cap can never be reached by a phone field and
        // CHANNEL_SUBTYPE_PHONE_ONLY is impossible from this always-phone UI, so both fall through to the
        // generic `editPhone.errors.serverError`. OP-6089: a too-short/too-long/unparseable value the
        // client length-check misses still 400s with CommunicationChannel.Phone.Invalid — map it to the
        // shared phone-field key (field labels come from the addPhone prefix via `field-i18n-prefix`).
        const ERROR_OVERRIDES = {
            'CommunicationChannel.Phone.Invalid': 'contact.detail.addPhone.errors.phoneInvalid',
        };
        function submitPhone(payload) {
            return updateContactPhone(props.contactId, props.channelId, {
                value: payload.value,
                isPrimary: payload.isPrimary,
                subType: payload.subType,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(EditPhoneModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "initial-value": __props.initialValue,
                "initial-is-primary": __props.initialIsPrimary,
                "initial-sub-type": __props.initialSubType,
                submit: submitPhone,
                "error-overrides": ERROR_OVERRIDES,
                "i18n-prefix": "contact.detail.editPhone",
                "field-i18n-prefix": "contact.detail.addPhone",
                onUpdated: _cache[1] || (_cache[1] = ($event) => (emit('updated'))),
                onDelete: _cache[2] || (_cache[2] = ($event) => (emit('delete')))
            }, null, 8 /* PROPS */, ["modelValue", "initial-value", "initial-is-primary", "initial-sub-type"]));
        };
    }
});
